module.exports = __webpack_public_path__ + "img/20180815_150609_104.d3270f47.jpg";